import React from 'react';
import DoneIcon from '@mui/icons-material/Done';
import PendingIcon from '@mui/icons-material/Pending';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import IdleIcon from '@mui/icons-material/HourglassEmpty';

export function ProjectStateIcon({ state }) {
  switch (state) {
    case 'finished':
      return <DoneIcon/>;
    case 'processing':
      return <PendingIcon/>;
    case 'failed':
      return <ErrorIcon/>;
    case 'idle':
    default:
      return <IdleIcon/>;
  }
}
